import React, { useState } from "react";
import Contact from "../contact";
import Testimonials from "../Testimonials";
import arrowIcon from "../../images/home/arrow-icon.svg";
import ellipticalIcon from "../../images/individual/ellipticalIcon.svg";
import rightVector from "../../images/individual/right-vector.svg";
import benifitIcon from "../../images/individual/benifitIcon.png";
import permanentIcon from "../../images/individual/permanent-resident.svg";
import visaImage from "../../images/individual/visa-assistance-image.png";
import helpIcon from "../../images/individual/helpIcon.svg";
import helpImage from "../../images/individual/immigetHelp.png";
import { FaPlus, FaTimes, FaExclamationTriangle, FaClock, FaGavel, FaCheckCircle, FaFileAlt, FaBan, FaSearch, FaRedo, FaUserCheck, FaDollarSign, FaUsers, FaHeart } from "react-icons/fa";
import unlimitedIcon from "../../images/individual/ic_outline-home-work.svg";
import iconPeople from "../../images/individual/akar-icons_people-group.svg";
import materialIcon from "../../images/individual/material-symbols_family-home-outline.svg";
import medicareIcon from "../../images/individual/icon-park-outline_medical-files.svg";
import { Helmet } from "react-helmet-async";

const VisaRefusalAppeal = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const testimonials = [
    {
      name: "Raj, India",
      content: "After my student visa refusal, Immiget Global helped me win at AAT. Now I'm studying in Sydney!",
      rating: 5
    },
    {
      name: "Sophie & Marco", 
      content: "Our partner visa was refused, but reapplying with Immiget's guidance got it approved!",
      rating: 5
    }
  ];

  const faqs = [
    {
      question: "Can I stay in Australia while appealing?",
      answer: "Yes, if you hold a bridging visa (varies by case)."
    },
    {
      question: "What's the success rate for AAT appeals?",
      answer: "30-50% for skilled visas, higher for partner visas."
    },
    {
      question: "How much does an appeal cost?",
      answer: "AAT fees: ~$3,500 AUD + professional fees."
    },
    {
      question: "Can I reapply immediately after refusal?",
      answer: "Yes, if you address the refusal reasons properly."
    }
  ];

  return (
    <div>
      <Helmet>
        <title>Visa Refusal Appeal Australia - Overturn Visa Rejection - Immiget Global</title>
        <meta name="description" content="Australian visa refused? Expert migration agents specialize in overturning visa rejections through AAT appeals, reapplications & ministerial interventions. Fight back today!" />
        <meta name="keywords" content="visa refusal appeal australia, visa rejected, AAT appeal, visa reapplication, ministerial intervention, immigration appeal lawyer australia" />
      </Helmet>

      {/* Hero Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex max-xl:flex-col justify-between max-xl:gap-6 xl:gap-[80px] xl:items-center">
          <div className="xl:w-[50%]">
            <h1 className="xl:text-[28px] text-[24px] max-xl:text-center text-blue mt-6 font-semibold hellix-font">
              Visa Refusal Appeal – Overturn Your Australian Visa Rejection
            </h1>
            <p className="max-xl:text-center hellix-font text-blue text-lg xl:text-[20px] font-normal">
              Has your Australian visa been refused? Don't lose hope – many visa refusals can be successfully appealed or reapplied for with the right strategy. At Immiget Global, our expert migration agents specialize in overturning visa rejections through appeals, reapplications, and ministerial interventions.
            </p>
          </div>
          <div className="xl:w-[50%] max-xl:justify-center max-xl:flex max-xl:mt-4">
            <img src={visaImage} alt="Visa Refusal Appeal" />
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Why Was Your Visa Refused */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            Why Was Your Visa Refused?
          </h1>
        </div>

        <div className="mt-8">
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <h3 className="text-blue text-2xl font-semibold hellix-font mb-6">
              Common reasons for visa refusals include:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[
                { icon: FaFileAlt, text: "Incorrect or incomplete documentation" },
                { icon: FaUserCheck, text: "Failure to meet health or character requirements" },
                { icon: FaExclamationTriangle, text: "Genuineness concerns (e.g., student or partner visas)" },
                { icon: FaBan, text: "Points test not met (for skilled visas)" },
                { icon: FaClock, text: "Previous visa cancellations or overstays" }
              ].map((reason, index) => {
                const IconComponent = reason.icon;
                return (
                  <div key={index} className="flex items-start gap-3 p-4 bg-red-50 rounded-lg">
                    <IconComponent className="text-red-500 text-lg mt-1 flex-shrink-0" />
                    <span className="text-blue hellix-font">{reason.text}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Your Options After Visa Refusal */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            Your Options After a Visa Refusal
          </h1>
        </div>

        <div className="mt-8 space-y-6">
          {/* Option 1: AAT Review */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">1</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Administrative Appeals Tribunal (AAT) Review
              </h3>
            </div>
            <div className="ml-16 space-y-3">
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-green-500 text-lg flex-shrink-0" />
                <span className="text-blue hellix-font">Lodge an appeal within strict deadlines (usually 21 days for most visas)</span>
              </div>
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-green-500 text-lg flex-shrink-0" />
                <span className="text-blue hellix-font">Present new evidence to support your case</span>
              </div>
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-green-500 text-lg flex-shrink-0" />
                <span className="text-blue hellix-font">Success rate varies – depends on refusal reasons</span>
              </div>
              <div className="flex items-center gap-2 p-3 bg-blue-50 rounded-lg mt-4">
                <FaClock className="text-blue text-lg flex-shrink-0" />
                <span className="text-blue hellix-font font-semibold">Processing Time: 12-24 months</span>
              </div>
            </div>
          </div>

          {/* Option 2: Reapply */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">2</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Reapply for the Visa (If Eligible)
              </h3>
            </div>
            <div className="ml-16 space-y-3">
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-green-500 text-lg flex-shrink-0" />
                <span className="text-blue hellix-font">Fix previous mistakes with a stronger application</span>
              </div>
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-green-500 text-lg flex-shrink-0" />
                <span className="text-blue hellix-font">Submit additional supporting documents</span>
              </div>
            </div>
          </div>

          {/* Option 3: Ministerial Intervention */}
          <div className="bg-white shadow-custom-white rounded-lg p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue text-white p-3 rounded-full">
                <span className="text-xl font-bold hellix-font">3</span>
              </div>
              <h3 className="text-blue text-2xl font-semibold hellix-font">
                Ministerial Intervention (Last Resort)
              </h3>
            </div>
            <div className="ml-16 space-y-3">
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-green-500 text-lg flex-shrink-0" />
                <span className="text-blue hellix-font">Request the Minister for Immigration to intervene (rare, only for exceptional cases)</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* How We Can Help */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={ellipticalIcon} alt="elliptical" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            How Immiget Global Can Help
          </h1>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            { 
              icon: FaSearch, 
              title: "Case Assessment", 
              text: "Identify why your visa was refused and the best appeal strategy." 
            },
            { 
              icon: FaGavel, 
              title: "AAT Appeal Preparation", 
              text: "Strong legal arguments + new evidence submission." 
            },
            { 
              icon: FaRedo, 
              title: "Visa Reapplication Support", 
              text: "Fix errors and strengthen your new application." 
            },
            { 
              icon: FaHeart, 
              title: "Ministerial Intervention Requests", 
              text: "For humanitarian or unique cases." 
            }
          ].map((service, index) => {
            const IconComponent = service.icon;
            return (
              <div key={index} className="bg-white shadow-custom-white rounded-lg p-6">
                <div className="flex items-center gap-3 mb-4">
                  <IconComponent className="text-blue text-2xl" />
                  <h3 className="text-blue text-xl font-semibold hellix-font">{service.title}</h3>
                </div>
                <p className="text-blue hellix-font">{service.text}</p>
              </div>
            );
          })}
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* CTA Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="bg-red-50 rounded-lg p-8 text-center">
          <h2 className="text-2xl text-blue font-bold hellix-font mb-4">
            Don't Accept a Visa Refusal – Fight Back!
          </h2>
          <p className="text-blue text-lg hellix-font mb-6">
            📞 Contact us immediately after refusal to meet deadlines.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={scrollToContact}
              className="px-8 py-3 bg-blue text-white font-semibold hellix-font rounded-lg hover:bg-blue-700 transition-colors"
            >
              Get a Free Refusal Assessment
            </button>
            <button 
              onClick={scrollToContact}
              className="px-8 py-3 bg-green-600 text-white font-semibold hellix-font rounded-lg hover:bg-green-700 transition-colors"
            >
              Speak to an Appeal Expert
            </button>
          </div>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* FAQs */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex gap-2">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h1 className="lg:text-[26px] text-2xl text-blue font-semibold hellix-font">
            FAQs
          </h1>
        </div>

        <div className="mt-8 space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white shadow-custom-white rounded-lg overflow-hidden">
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none"
              >
                <h3 className="text-blue font-semibold hellix-font text-lg">
                  ❓ {faq.question}
                </h3>
                {activeIndex === index ? (
                  <FaTimes className="text-blue text-lg" />
                ) : (
                  <FaPlus className="text-blue text-lg" />
                )}
              </button>
              {activeIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-blue hellix-font">• {faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Testimonials */}
      <div className="py-6 xl:py-10">
        <Testimonials testimonials={testimonials} title="Testimonials" />
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Final CTA Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="bg-yellow-50 rounded-lg p-8 text-center">
          <h2 className="text-2xl text-blue font-bold hellix-font mb-4">
            Act Fast – Strict Deadlines Apply!
          </h2>
          <p className="text-blue text-lg hellix-font mb-6">
            Visa refusal appeals have short time limits (often 21 days). Let our experts assess your case today.
          </p>
          <button 
            onClick={scrollToContact}
            className="px-8 py-3 bg-blue text-white font-semibold hellix-font rounded-lg hover:bg-blue-700 transition-colors"
          >
            Start Your Appeal Now
          </button>
        </div>
      </div>

      {/* How We Help Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="flex max-lg:flex-col justify-between gap-6 lg:gap-[80px] lg:items-center">
          <div className="lg:w-[50%]">
            <div className="flex gap-2">
              <div className="flex items-center">
                <img src={helpIcon} alt="help" />
              </div>
              <h1 className="text-[26px] text-blue font-semibold hellix-font">
                How Immiget Global Can Help
              </h1>
            </div>
            <p className="hellix-font text-blue text-lg font-normal mt-4">
              Our experienced migration agents understand the frustration of visa refusals. We provide comprehensive assessment, strategic appeals, and expert guidance throughout the entire process. With our proven track record in overturning visa rejections, we give you the best chance of success.
            </p>
            <div className="flex gap-4 mt-6">
              <button 
                onClick={scrollToContact}
                className="px-6 py-3 bg-blue text-white font-semibold hellix-font rounded-lg hover:bg-blue-700 transition-colors"
              >
                Contact Us Today
              </button>
            </div>
          </div>
          <div className="lg:w-[50%] max-lg:justify-center max-lg:flex">
            <img src={helpImage} alt="How we can help" />
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div id="contact-section">
        <Contact />
      </div>
    </div>
  );
};

export default VisaRefusalAppeal;